var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Gift Card"}},[_c('v-text-field',{attrs:{"label":"Search","append-icon":"mdi-magnify","solo":"","flat":"","dense":""},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}}),_c('Table',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }